var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-select',{attrs:{"interface":"alert","value":_vm.currentLanguage},on:{"ionChange":function($event){return _vm.changeLanguage($event.target.value)}}},_vm._l((_vm.languages),function(language){return _c('ion-select-option',{key:language.locale,attrs:{"value":language.locale}},[_vm._v(" "+_vm._s(language.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }